import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Card } from '../components/Card';
import { Button } from '../components/Button';

const REDIRECT_DELAY_MS = 5000;

export function CheckoutSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_DELAY_MS / 1000);
  const transactionId = searchParams.get('_ptxn');

  useEffect(() => {
    const timer = setTimeout(() => navigate('/', { replace: true }), REDIRECT_DELAY_MS);
    const countdown = setInterval(() => setSecondsLeft((s) => s - 1), 1000);
    return () => { clearTimeout(timer); clearInterval(countdown); };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="max-w-md w-full">
        <div className="space-y-4 text-center">
          <div className="mx-auto w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
            <Check className="h-6 w-6 text-success" />
          </div>
          <h2 className="text-xl font-semibold text-foreground">Payment Successful</h2>
          <p className="text-sm text-muted-foreground">
            Your subscription is now active. Welcome to Varinym.
          </p>
          {transactionId && (
            <p className="text-xs text-muted-foreground font-mono bg-muted/50 rounded px-3 py-2">
              Transaction: {transactionId}
            </p>
          )}
          <p className="text-sm text-muted-foreground">
            Redirecting to dashboard in {secondsLeft}s…
          </p>
          <Button onClick={() => navigate('/', { replace: true })} className="w-full">
            Go to Dashboard Now
          </Button>
        </div>
      </Card>
    </div>
  );
}
